const svTranslations = {
  title: "Artem Ryabinin",
  profile: {
    title: "Profil",
    content: "IT-utvecklare med över 15 års branscherfarenhet. Fullstack-utvecklingsexpert med djup kunskap inom backend-teknologier och AI-implementering. Dokumenterad historik av framgångsrik projektleverans för stora företag och startups, där teknisk expertis kombineras med strategiskt tänkande och ledarskapsegenskaper."
  },
  expertise: {
    title: "Expertisområden",
    items: [
      "Webbutveckling (webbplatser, informationsportaler)",
      "Företagsmjukvara (CRM- och ERP-system)",
      "Skräddarsydd mjukvaruutveckling för unika affärsbehov",
      "Utveckling av chatbotar och AI-assistenter",
      "Mobilapplikationsutveckling",
      "System för förstärkt verklighet",
      "Säkerhetsrevision och sårbarhetsanalys",
      "Affärsanalys och systemanalys",
      "Big Data-behandling och analys med ML och TensorFlow",
      "Utveckling och träning av neurala nätverk för social media-analys",
      "Komplex problemlösning och AI-forskning",
      "Design och implementering av mikrotjänstarkitektur",
      "Applikationscontainerisering med Docker",
      "Integrering och driftsättning av molninfrastruktur med AWS"
    ]
  },
  skills: {
    title: "Nyckelkompetenser",
    items: [
      "Programmeringsspråk: Go, Python, TypeScript/JavaScript, PHP (tidigare erfarenhet)",
      "Ramverk: Django, React, GIN",
      "Backend-utvecklingsspecialisering, djup kunskap om serverarkitektur",
      "Fullstack-utveckling med starkt backend-fokus",
      "UX/UI-design",
      "Projekt- och utvecklingsteamledning",
      "Implementering av neurala nätverk i utveckling",
      "Anpassning till nya teknologier och metoder",
      "Optimering av affärsprocesser, inklusive AI-systemintegration",
      "Design och implementering av mikrotjänstarkitektur",
      "Applikationscontainerisering med Docker",
      "AWS-applikationsdriftsättning och hantering",
      "Databashantering: PostgreSQL, MongoDB",
      "Erfarenhet av utveckling och optimering av högbelastningssystem"
    ]
  },
  achievements: {
    title: "Professionella prestationer",
    items: [
      "Ökade utvecklingseffektiviteten med 28% genom AI-verktygsintegrering i arbetsflödet",
      "Framgångsrikt slutfört över 50 projekt för Fortune 500-kunder",
      "Grundade det mycket lönsamma företaget RownArts, som snabbt blev ledande inom sin nisch",
      "Utvecklade och implementerade ett innovativt system för arbetsflödesoptimering, vilket ökade teamets produktivitet med 32%"
    ]
  },
  experience: {
    title: "Arbetslivserfarenhet",
    jobs: [
      {
        title: "Frilansare och oberoende utvecklare",
        period: "2020 - nu",
        details: [
          "Specialisering inom backend-utveckling (främst Go och Python)",
          "Implementering av högbelastningsprojekt för Moskvas statliga universitet, Sberbank och olika kryptoprojekt",
          "Implementering av AI för utvecklingsoptimering och dataanalys sedan 2021",
          "Utveckling och implementering av innovativa backend-lösningar för prestandaoptimering"
        ]
      },
      {
        title: "UX/UI-specialist och React-utvecklare, Neurodoc",
        period: "2019",
        details: [
          "Skapade Neurodocs UI/UX-system från grunden inom snäva tidsramar",
          "Utveckling av responsiva och tillgängliga frontend-lösningar med React"
        ]
      },
      {
        title: "Lead Frontend-utvecklare, RedCrypto",
        period: "2018",
        details: [
          "Ledde ett team på 5 utvecklare",
          "Implementerade Agile-metodik, vilket minskade produktlanseringstiden med 40%"
        ]
      },
      {
        title: "Grundare och teamledare, RownArts",
        period: "2013 - 2018",
        details: [
          "Utvecklade företaget från startup till ett team på 15 specialister",
          "Nyckelroll i att attrahera och behålla kunder som Bacardi, Volkswagen Group, Parliament, MTS, Aeroflot, Sber",
          "Utveckling av innovativa backend-lösningar med Python, Django och .NET MVC"
        ]
      },
      {
        title: "Projektledare, Mosaic Media",
        period: "2013, 5 månader",
        details: [
          "Framgångsrikt hanterade parallell utveckling av 3 stora projekt",
          "Implementerade kvalitetskontrollsystem som minskade antalet buggar med 57%"
        ]
      },
      {
        title: "Frilansare",
        period: "2008 - 2013",
        details: [
          "Slutförde över 30 projekt av varierande komplexitet med fokus på backend-utveckling",
          "Utvecklade fullstack-kompetenser med fokus på backend (PHP, senare Python) under universitetsutbildningen",
          "Skapade och optimerade backend-system för kunder inom olika branscher"
        ]
      }
    ]
  },
  education: {
    title: "Utbildning",
    items: [
      {
        institution: "Bauman Moskvas Statliga Tekniska Universitet",
        degree: "Maskinteknik, 2013",
      }
    ]
  },
  additionalEducation: {
    title: "Vidareutbildning",
    items: [
      "Deep Learning-specialiseringskurs av deeplearning.ai, 2021"
    ]
  },
  earlyExperience: {
    title: "Tidig erfarenhet",
    content: "Implementering av kommersiella projekt för internationella kunder (AMK technologies, Olga Widman) under gymnasieåren"
  },
  additionalInfo: {
    title: "Ytterligare information",
    items: [
      "Aktiv medlem i open source-communityn: bidragsgivare till Django- och TensorFlow-projekt",
      "Mentor för juniora utvecklare i den lokala IT-communityn",
      "Kontinuerlig självutbildning och behärskning av toppmoderna teknologier"
    ]
  }
};

export default svTranslations;